import React, { useState } from 'react'
import { Card, CardGroup, Carousel, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../../common/VideoPlayerModal';

const ProductModeling = () => {

    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)

    const openVideoModal = (data) => {
        setModalShow(true)
        setVideoUrl(data)

    }

  return (
    <>
        <Card className='product-modeling-container no-border rounded-0 container'>
            <Row className=''>
                <Col sm={12} md={4}>
                    <Card className='no-border rounded-0 container product-modeling-card'>
                        <Card.Body className='product-modeling-card-body py-2'>
                            <Card.Title className='product-modeling-card-title py-2'> 製品・商品を3Dモデル化／アニメーション表現 </Card.Title>
                            <Card.Text className="product-modeling-card-body-text py-1">
                            大規模なEC事業会社だけでなく、その他の物理的な製品会社も、3Dモデルを使った写真の置き換えの恩恵を受けることができます。
                            <br /> 
                            <br /> 
                            製品によっては、従来の静止画では十分な効果が得られないものもあります。マーケティング、広告、販売には、高画質で詳細な画像を表示することが重要ですが、フォトグラメトリーは、従来の写真よりも多くの選択肢を提示することができます。
                            <br /> 
                            <br /> 
                            3D製品モデルは、従来の写真だけで
                            は表現しきれなかった製品の特徴や
                            機能、内蔵部品などをアニメーショ
                            ンで表現した動画を作成することが
                            できます。                            
                            </Card.Text>
                            <div className='product-border py-2'></div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={12} md={8} className="product-modeling-video-list">
                    <Carousel className='product-carousel' variant="dark" fade indicators={false} interval={null}>
                        <Carousel.Item >
                        <CardGroup className='row'>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('Canon_3D Modeling.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/canon.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>・Canon（キヤノン） EOSシリーズ レンズ交換式カメラ</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Selfie_Light.mp4')}>
                                <Card.Img src={"/assets/product-modeling/thumbnails/selfie-light.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>・セルフィーライト</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Wireless_Charger.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/charger.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'> ・ワイヤレス充電器 </Card.Title>
                            </Card>
                        </CardGroup>
                        </Carousel.Item>
                        <Carousel.Item >
                        <CardGroup className='row'>
                            
                        <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Selfie_Light.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/selfie-light.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>・セルフィーライト</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Wireless_Charger.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/charger.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'> ・ワイヤレス充電器 </Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('Canon_3D Modeling.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/canon.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>・Canon（キヤノン） EOSシリーズ レンズ交換式カメラ</Card.Title>
                            </Card>
                        </CardGroup>
                        </Carousel.Item>
                        <Carousel.Item >
                        <CardGroup className='row'>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Wireless_Charger.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/charger.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'> ・ワイヤレス充電器 </Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('Canon_3D Modeling.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/canon.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>・Canon（キヤノン） EOSシリーズ レンズ交換式カメラ</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section'  onClick={() => openVideoModal('AmeriChip_Selfie_Light.mp4')}>
                                    <Card.Img src={"/assets/product-modeling/thumbnails/selfie-light.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={"/assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>・セルフィーライト</Card.Title>
                            </Card>
                        </CardGroup>
                        </Carousel.Item>

                    </Carousel>
                </Col>
            </Row>
        </Card>

        <VideoPlayerModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videosrc={'/assets/product-modeling/videos/' + videoUrl}
      />
    </>
  )
}

export default ProductModeling
